module.exports = __webpack_public_path__ + "media/assets/svgs/facebook-352ce0706a9a9fed35fcf47375a5f03a.svg";